import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: () => ({
    color: '#FF0000',
    image: 'https://i.imgur.com/045f4o1.png',
    timer: {
      time: 180,
      enable: false,
    },
    interest: {
      type: 'financial',
      fixed: null,
      flexible: 0,
      settings: null,
      installments: 12,
    },
    payments: [],
    free_freight: {
      amount: 899.9,
      enable: false,
    },
    email_required: 0,
  }),
  mutations,
  getters,
}
